<template>
  <span v-tooltip="tooltip" :class="spanClass"> {{ met }} / {{ total }} </span>
</template>

<script>
export default {
  name: 'SLOItem',
  props: {
    row: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    slo() {
      return this.row.slos || {};
    },
    met() {
      return this.slo.met || 0;
    },
    total() {
      return this.slo.total || 0;
    },
    tooltip() {
      if (this.met === this.total) {
        return 'All SLOs met';
      }
      const missed = this.slo.objectives
        .filter(({ met }) => !met)
        .map(({ metric }) => metric.toUpperCase());
      return `Missed SLOs for ${missed.join(', ')}`;
    },
    spanClass() {
      return {
        badge: true,
        'badge-pass': this.total && this.met === this.total,
        'badge-fail': this.total && this.met !== this.total,
        'badge-nodata': !this.total,
      };
    },
  },
};
</script>

<style scoped>
.badge-nodata {
  background-color: #999999 !important;
}
.badge-pass {
  background-color: var(--pass) !important;
  color: var(--dark-main);
}
.badge-fail {
  background-color: var(--fail) !important;
}
</style>
